import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-keypad',
  imports: [CommonModule],
  templateUrl: './keypad.component.html',
  styleUrls: ['./keypad.component.css'],
})
export class KeypadComponent implements OnInit, OnChanges {
  @Output() clickEvent = new EventEmitter<any>();
  @Input() callActive: boolean = false;
  @Input() disabled: boolean = true;
  @Input() showCallBtn: boolean = true;

  deviceRegistered: boolean = false;

  lastKeys: string = '';

  ngOnInit() {
    this.deviceRegistered =
      localStorage.getItem('deviceRegistered') == 'true' ? true : false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disabled']) {
      this.disabled = changes['disabled'].currentValue;
    }
  }

  onDigitClick(digit: string | number) {
    this.lastKeys += String(digit);
    this.clickEvent.emit({ type: 'digit', value: String(digit) });
  }

  openModal(event: any) {
    this.clickEvent.emit(event);
  }

  onBackspaceClick() {
    if (this.lastKeys.length > 0) {
      this.lastKeys = this.lastKeys.slice(0, -1); // remove last character
    }
  }
}
